<template>
  <div class="sr-status" :class="{'sr-status--with-background': withBackground}">
    <div class="sr-status-background" :class="'sr-status-background--' + STATUS.TYPE"></div>
    <div class="sr-status-content" :class="'sr-status-content--' +  STATUS.TYPE">
      {{ STATUS.LABEL }}
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import commonComp from '@/compositions/modules/common'
import { commonUtils } from '@libs/utils'

export default {
  name: 'sr-status',
  props: {
    category: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    },
    withBackground: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { dict } = commonComp()
    const scopedComp = {
      dict
    }
    const scopedComputed = {
      STATUS: computed(() => {
        const visible = !commonUtils.isEmpty(props.category) && !commonUtils.isEmpty(props.code)
        return {
          LABEL: (() => {
            return visible ? dict[props.category].mappings[props.code].label : ''
          })(),
          TYPE: (() => {
            return visible ? dict[props.category].mappings[props.code].type : ''
          })()
        }
      })
    }
    return {
      ...scopedComp,
      ...scopedComputed
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.sr-status {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  line-height: 20px;
  .sr-status-content {
    padding: $--padding-small $--padding-medium;
    border-radius: 20px;
    font-size: $--font-size-base;
    opacity: 1;
  }
  .sr-status-content::before {
    content: '';
    position: relative;
    right: 5px;
    display: inline-block;
    width: 4px;
    height: 4px;
    vertical-align: middle;
    border-radius: 50%;
  }
  .sr-status-content--default {
    color: $--color-grey-heavy;
  }
  .sr-status-content--success {
    color: $--color-green;
  }
  .sr-status-content--warning {
    color: $--color-orange;
  }
  .sr-status-content--danger {
    color: $--color-red;
  }
  .sr-status-content--primary {
    color: $--color-primary;
  }
  .sr-status-content--default::before {
    background-color: $--color-grey-heavy;
  }
  .sr-status-content--success::before {
    background-color: $--color-green;
  }
  .sr-status-content--warning::before {
    background-color: $--color-orange;
  }
  .sr-status-content--danger::before {
    background-color: $--color-red;
  }
  .sr-status-content--primary::before {
    background-color: $--color-primary;
  }
}

.sr-status--with-background {
  .sr-status-background {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: .2;
  }
  .sr-status-background--default {
    background-color: $--color-grey-heavy;
  }
  .sr-status-background--success {
    background-color: $--color-green;
  }
  .sr-status-background--warning {
    background-color: $--color-orange;
  }
  .sr-status-background--danger {
    background-color: $--color-red;
  }
  .sr-status-background--primary {
    background-color: $--color-primary;
  }
}

</style>
